import React from "react"
import { ui } from "../styles/uiSystem"

export default function PageHero({
  eyebrow,
  title,
  subtitle,
  actions = null,
  metrics = [],
  background = null,
  compact = false
}) {
  if (compact) {
    return (
      <div
        style={{
          marginBottom: 10,
          borderRadius: 16,
          border: "1px solid #e2e8f0",
          background: "rgba(255,255,255,0.96)",
          boxShadow: "0 6px 16px rgba(15,23,42,0.04)",
          padding: "9px 12px",
          minWidth: 0
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: actions ? "minmax(0, 1fr) auto" : "1fr",
            gap: 10,
            alignItems: "center",
            minWidth: 0
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              flexWrap: "wrap",
              minWidth: 0
            }}
          >
            <div style={{ minWidth: 0 }}>
              {eyebrow ? (
                <div
                  style={{
                    fontSize: 9.5,
                    fontWeight: 950,
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    color: "#64748b",
                    lineHeight: 1
                  }}
                >
                  {eyebrow}
                </div>
              ) : null}

              <div
                style={{
                  marginTop: eyebrow ? 2 : 0,
                  fontSize: 18,
                  fontWeight: 950,
                  lineHeight: 1.05,
                  letterSpacing: "-0.03em",
                  color: "#0f172a"
                }}
              >
                {title}
              </div>
            </div>

            {metrics?.length ? (
              <div
                style={{
                  display: "flex",
                  gap: 6,
                  flexWrap: "wrap",
                  minWidth: 0
                }}
              >
                {metrics.map((metric) => (
                  <div
                    key={metric.label}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 5,
                      minHeight: 24,
                      padding: "0 8px",
                      borderRadius: 999,
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                      color: "#334155",
                      fontSize: 11,
                      fontWeight: 850,
                      whiteSpace: "nowrap"
                    }}
                  >
                    <span style={{ color: "#64748b", fontWeight: 750 }}>
                      {metric.label}
                    </span>
                    <span style={{ color: "#0f172a", fontWeight: 950 }}>
                      {metric.value}
                    </span>
                  </div>
                ))}
              </div>
            ) : null}

            {subtitle ? (
              <div
                style={{
                  flex: "1 1 260px",
                  color: "#64748b",
                  fontSize: 12,
                  lineHeight: 1.3,
                  minWidth: 0
                }}
              >
                {subtitle}
              </div>
            ) : null}
          </div>

          {actions ? (
            <div
              style={{
                display: "flex",
                gap: 8,
                flexWrap: "wrap",
                justifyContent: "flex-end"
              }}
            >
              {actions}
            </div>
          ) : null}
        </div>
      </div>
    )
  }

  return (
    <div
      style={{
        ...ui.heroCard,
        marginBottom: 16,
        background: background || ui.heroCard.background
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at top right, rgba(255,255,255,0.18), transparent 36%)",
          pointerEvents: "none"
        }}
      />

      <div
        style={{
          position: "relative",
          zIndex: 1,
          display: "grid",
          gap: 16
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: actions ? "minmax(0,1fr) auto" : "1fr",
            gap: 14,
            alignItems: "start"
          }}
        >
          <div style={{ minWidth: 0 }}>
            {eyebrow ? (
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 900,
                  textTransform: "uppercase",
                  letterSpacing: 0.08 + "em",
                  color: "rgba(255,255,255,0.76)",
                  marginBottom: 6
                }}
              >
                {eyebrow}
              </div>
            ) : null}

            <div style={ui.heroTitle}>{title}</div>

            {subtitle ? (
              <div style={ui.heroSubtitle}>
                {subtitle}
              </div>
            ) : null}
          </div>

          {actions ? (
            <div
              style={{
                display: "flex",
                gap: 8,
                flexWrap: "wrap",
                justifyContent: "flex-end"
              }}
            >
              {actions}
            </div>
          ) : null}
        </div>

        {metrics?.length ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
              gap: 12
            }}
          >
            {metrics.map((metric) => (
              <div
                key={metric.label}
                style={{
                  borderRadius: 16,
                  padding: 14,
                  background: "rgba(255,255,255,0.12)",
                  border: "1px solid rgba(255,255,255,0.16)",
                  backdropFilter: "blur(8px)"
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: "rgba(255,255,255,0.78)",
                    marginBottom: 8,
                    fontWeight: 700
                  }}
                >
                  {metric.label}
                </div>

                <div
                  style={{
                    fontWeight: 900,
                    fontSize: 30,
                    lineHeight: 1,
                    color: "#ffffff",
                    letterSpacing: "-0.03em"
                  }}
                >
                  {metric.value}
                </div>

                {metric.helper ? (
                  <div
                    style={{
                      fontSize: 11,
                      color: "rgba(255,255,255,0.72)",
                      marginTop: 8,
                      lineHeight: 1.3
                    }}
                  >
                    {metric.helper}
                  </div>
                ) : null}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  )
}
